import { render } from "./RatingSetModal.vue?vue&type=template&id=c6f4daa4&scoped=true"
import script from "./RatingSetModal.vue?vue&type=script&lang=js"
export * from "./RatingSetModal.vue?vue&type=script&lang=js"

import "./RatingSetModal.vue?vue&type=style&index=0&id=c6f4daa4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f4daa4"]])

export default __exports__